import { BrandTheme, XyzTheme } from '@postidigital/posti-theme'
import PropTypes from 'prop-types'
import React, { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

export const combinedTheme = { ...XyzTheme, brand: BrandTheme }

const ThemeWrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={combinedTheme}>
    <>{children}</>
  </ThemeProvider>
)

ThemeWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default ThemeWrapper
